import { StandardProps } from "@/types/types";
import styles from "./Title.module.scss";
import { TitleText } from "../__shared__/TitleText/TitleText";
import { useRouteParams } from "@/hooks/useRouteParams";
import { TotalItems } from "./components/TotalItems/TotalItems";
import classNames from "classnames";

export function Title({
  productListingData,
  configProps,
}: Pick<StandardProps, "productListingData" | "configProps">) {
  const {
    pageInformation: { heading, subHeading },
    results,
    crumbs,
    correction,
  } = productListingData;

  const finalHeadingText =
    heading ||
    crumbs
      ?.map((crumb) => crumb.displayName)
      .slice(-2)
      .join(" & ") ||
    "";

  const showTotalItems = configProps?.totalItems === true;

  const shouldShowNumberOfResults = !showTotalItems && results > 0;
  const finalResultCount = correction?.correctedSearchTerm ? 0 : results;

  const { pageType, query } = useRouteParams();
  const hasListHeadQueryParam = pageType === "search" && query?.listHead;

  const finalHeading =
    pageType === "search" ? `'${finalHeadingText}'` : finalHeadingText;

  if (showTotalItems) {
    return (
      <div
        data-component="Title"
        className={classNames(styles.container, {
          [styles.withTotal!]: configProps?.totalItems,
        })}
      >
        <div className={styles.titleWrapper}>
          {hasListHeadQueryParam ? (
            <TitleText
              heading={
                Array.isArray(query.listHead)
                  ? query.listHead[0]
                  : query.listHead
              }
            />
          ) : (
            <>
              <TitleText heading={finalHeading} subHeading={subHeading} />
              {shouldShowNumberOfResults && (
                <span className={styles.resultCount} data-testid="result-count">
                  <span className={styles.bracket}>(</span>
                  {finalResultCount}
                  <span className={styles.bracket}>)</span>
                </span>
              )}
            </>
          )}
        </div>
        <TotalItems productListingData={productListingData} />
      </div>
    );
  }

  return (
    <div
      data-component="Title"
      className={classNames(styles.container, {
        [styles.withTotal!]: configProps?.totalItems,
      })}
    >
      {hasListHeadQueryParam ? (
        <TitleText
          heading={
            Array.isArray(query.listHead) ? query.listHead[0] : query.listHead
          }
        />
      ) : (
        <>
          <TitleText heading={finalHeading} subHeading={subHeading} />
          {shouldShowNumberOfResults && (
            <span className={styles.resultCount} data-testid="result-count">
              <span className={styles.bracket}>(</span>
              {finalResultCount}
              <span className={styles.bracket}>)</span>
            </span>
          )}
        </>
      )}
    </div>
  );
}
